import React from 'react';
import Select from '../../../components/ui/Select';

const PostingFrequencySelect = ({ value, onChange, error }) => {
  const frequencyOptions = [
    { value: 'daily', label: 'Daily (7+ posts/week)' },
    { value: '4-6-weekly', label: '4-6 times per week' },
    { value: '2-3-weekly', label: '2-3 times per week' },
    { value: 'weekly', label: 'Once a week' },
    { value: 'bi-weekly', label: 'Every 2 weeks' },
    { value: 'monthly', label: 'Monthly or less' }
  ];

  return (
    <Select
      label="Content Posting Frequency"
      description="How often do you typically post content?"
      options={frequencyOptions}
      value={value}
      onChange={onChange}
      error={error}
      placeholder="Select posting frequency"
    />
  );
};

export default PostingFrequencySelect;